export default __webpack_public_path__ + "static/media/skb_logo.8838040b.png";